import Logo from "../../components/Logo";
import { useNavigate } from "react-router-dom";

export default function MinistryLogin() {
  const navigate = useNavigate();

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const ident = String(form.get("ident") || "").trim();
    if (ident) {
      localStorage.setItem("ministry.user", JSON.stringify({ ident }));
      navigate("/ministere/dashboard");
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-lg">
          <div className="flex justify-center">
            <Logo />
          </div>
          <form className="mt-10 space-y-4" onSubmit={onSubmit}>
            <div className="space-y-2">
              <label className="text-sm" style={{ color: "#000000" }}>
                Identifiants
              </label>
              <input name="ident" className="w-full h-12 rounded-[10px] border-2 px-3" style={{ borderColor: "#D1E2DD" }} />
            </div>
            <button
              type="submit"
              className="w-full h-11 rounded-[10px] font-semibold text-white cursor-pointer"
              style={{ background: "#00553E" }}
            >
              Connectez-vous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

